import axios from 'axios';
import { API_URL, authHeader } from "./auth-header";

class CondoService {

    get() {
        return axios.get(API_URL + 'condominio/get', { headers: authHeader() }).then(response => {
            if (!response.data.error) {
              return response.data.data;
            }
    
            return false;
          });
    }

    insert(cod_servizio,fiscal_code,denominazione,comune,provincia,indirizzo,civico,pec) {
        return axios
          .post(API_URL + "condominio/insert", {
            cod_servizio,
            fiscal_code, 
            denominazione,
            comune,
            provincia,
            indirizzo,
            civico,
            pec
          },{ headers: authHeader() })
          .then(response => {
            if (!response.data.error) {
              return response.data.data;
            }
    
            return response.data;
          });
    }

    insertSub(condo_id, fiscal_code,denominazione,utilizzo,ncf,telefono) {
        condo_id = parseInt(condo_id);
        return axios
          .post(API_URL + "condominio/insert_sub", {
            condo_id,
            fiscal_code, 
            denominazione,
            utilizzo,
            ncf,
            telefono
          },{ headers: authHeader() })
          .then(response => {
            if (!response.data.error) {
              return response.data.data;
            }
    
            return response.data;
          });
    }

    insertSubCalc(condo_id,fiscal_code, denominazione, utilizzo, ncf, data_inizio, data_fine, consumo, flag_fog, flag_dep) {
      condo_id = parseInt(condo_id);
      return axios
        .post(API_URL + "condominio/insert_sub_calc", {
          condo_id,
          fiscal_code, 
          denominazione,
          utilizzo,
          ncf,
          data_inizio,
          data_fine,
          consumo,
          flag_fog,
          flag_dep,
        },{ headers: authHeader() })
        .then(response => {
          if (!response.data.error) {
            return response.data.data;
          }
  
          return response.data;
        });
    }

    getSub(condo_id) {
        return axios.post(API_URL + 'condominio/get_sub', {
            condo_id,
          }, { headers: authHeader() }).then(response => {
            if (!response.data.error) {
              return response.data.data;
            }
    
            return false;
          });
    }

    calcolaTariffe(condo_id, importo){
      condo_id = parseInt(condo_id);
        return axios
          .post(API_URL + "condominio/calcola_tariffa", {
            condo_id,
            importo, 
          },{ headers: authHeader() })
          .then(response => {
            if (!response.data.error) {
              return response.data.data;
            }
    
            return response.data;
          });
    }

    calcolaTariffeCalc(condo_id, importo){
      condo_id = parseInt(condo_id);
        return axios
          .post(API_URL + "condominio/calcola_tariffa_calc", {
            condo_id,
            importo, 
          },{ headers: authHeader() })
          .then(response => {
            if (!response.data.error) {
              return response.data.data;
            }
    
            return response.data;
          });
    }

    editSub(data) {
      return axios
        .post(API_URL + "condominio/edit_sub", data,{ headers: authHeader() })
        .then(response => {
          if (!response.data.error) {
            return response.data.data;
          }
          return response.data;
        });
    }

    calcSingSub(data) {
      return axios
        .post(API_URL + "condominio/calc_sing_sub", data,{ headers: authHeader() })
        .then(response => {
          if (!response.data.error) {
            return response.data.data;
          }
          return response.data;
        });
    }

    deleteSub(condosub_id) {
      condosub_id = parseInt(condosub_id);
      return axios
        .post(API_URL + "condominio/delete_sub", {
          condosub_id,
        },{ headers: authHeader() })
        .then(response => {
          if (!response.data.error) {
            return response.data.data;
          }
          return response.data;
        });
    }
    
    deleteCond(condo_id) {
      condo_id = parseInt(condo_id);
      return axios
        .post(API_URL + "condominio/delete", {
          condo_id,
        },{ headers: authHeader() })
        .then(response => {
          if (!response.data.error) {
            return response.data.data;
          }
          return response.data;
        });
    }
}

export default new CondoService();